<template>
  <v-row>
    <v-col cols="12" md="12">
      <BaseBlock title="Page publique">
        <h2 class="subtitle-1 font-weight-bold">Page publique</h2>
        <p>
          Cette page est accessible à l'ensemble des utilisateurs sans
          restriction
        </p>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "PublicPage",
  components: { BaseBlock },
};
</script>
